var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[(_vm.icon)?_c('img',{staticClass:"card-icon",attrs:{"src":_vm.resolvedIcon,"alt":"Icon"}}):_vm._e(),_c('h3',[_vm._v(_vm._s(_vm.title))])]),_c('div',{staticClass:"card-body"},[_c('p',{class:_vm.valueClass},[_vm._v(_vm._s(_vm.value))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }